/* import __COLOCATED_TEMPLATE__ from './editor.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import type PhoneHoldAndAssign from 'embercom/models/operator/visual-builder/step/phone-hold-and-assign';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import type Store from '@ember-data/store';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface Arguments {
  step: PhoneHoldAndAssign;
  isReadOnly: boolean;
  editorState: EditorState;
}

export default class PhoneHoldAndAssignEditor extends Component<Arguments> {
  @service declare store: Store;
  @tracked selectedTab = 'answer';

  teamAssignmentAction: any;

  constructor(owner: unknown, args: Arguments) {
    super(owner, args);

    this.teamAssignmentAction = this.store.createFragment('rules/rule-action', {
      type: 'assign-conversation',
      actionData: {
        skip_assigned: false,
        assignee_id: this.args.step.teamId,
      },
    });
  }

  @action
  onChange() {
    this.args.step.teamId = this.teamAssignmentAction.actionData.assignee_id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::PhoneHoldAndAssign::Editor': typeof PhoneHoldAndAssignEditor;
    'workflows/graph-editor/node-items/steps/phone-hold-and-assign/editor': typeof PhoneHoldAndAssignEditor;
  }
}
